import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Title = styled.p(() =>
  mq({
    textAlign: 'center',
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    margin: `${defaultTheme.spacing.s} 0 ${defaultTheme.spacing.xxl}`,
  }),
);
